import { useEffect } from "react";

const useNegativeTotalAdvice = ({ subTotal, finalTotal, isMain }) => {
  useEffect(() => {
    if (subTotal > 0 && finalTotal < 0 && isMain) {
      alert(
        "Discount is greater than contract total, check your discount section!"
      );
    }
  }, [subTotal, finalTotal, isMain]);
};

export default useNegativeTotalAdvice;
